document.addEventListener('click', function (event) {
  const swatch = event.target.closest('[data-linked-swatch]');
  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();
  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }

  const card = swatch.closest('[data-product-card]');
  if (!card) return;

  const links = card.querySelectorAll('[data-card-product-link]');
  const titleEl = card.querySelector('[data-card-title]');
  const secondaryTitleEl = card.querySelector('[data-card-title-secondary]');
  const swatchNameEl = card.querySelector('[data-card-swatch-name]');
  const mainImage = card.querySelector('[data-card-main-image]');
  const secondaryImage = card.querySelector('[data-card-secondary-image]');
  const priceContainer = card.querySelector('[data-card-price]');
  const badgeContainer = card.querySelector('[data-card-badge]');
  const badgeTopContainer = card.querySelector('[data-card-badge-top]');
  const badgeInlineContainer = card.querySelector('[data-card-badge-inline]');
  const allSwatches = card.querySelectorAll('[data-linked-swatch]');

  const productUrl = swatch.dataset.productUrl || '';
  const productTitle = swatch.dataset.productTitle || '';
  const productSwatchName = swatch.dataset.productSwatchName || '';
  const productMainImage = swatch.dataset.productMainImage || '';
  const productMainImageSrcset = swatch.dataset.productMainImageSrcset || '';
  const productMainAlt = swatch.dataset.productMainAlt || '';
  const productSecondaryImage = swatch.dataset.productSecondaryImage || '';
  const productSecondaryImageSrcset = swatch.dataset.productSecondaryImageSrcset || '';
  const productHasSecondary = swatch.dataset.productHasSecondary || 'false';
  const priceTemplateId = swatch.dataset.priceTemplateId || '';
  const badgeTemplateId = swatch.dataset.badgeTemplateId || '';
  const productOnSale = swatch.dataset.productOnSale || 'false';
  const productFinalSale = swatch.dataset.productFinalSale || 'false';

  links.forEach(function(link) {
    link.setAttribute('href', productUrl);
  });

  const productTitleHtml = swatch.dataset.productTitleHtml || '';

  if (titleEl) {
    if (productTitleHtml) {
      titleEl.innerHTML = productTitleHtml;
    } else {
      titleEl.textContent = productTitle;
    }
  }

  if (secondaryTitleEl) {
    if (productTitleHtml) {
      secondaryTitleEl.innerHTML = productTitleHtml;
    } else {
      secondaryTitleEl.textContent = productTitle;
    }
  }

  if (swatchNameEl) {
    if (productSwatchName) {
      swatchNameEl.textContent = productSwatchName;
      swatchNameEl.hidden = false;
    } else {
      swatchNameEl.textContent = '';
      swatchNameEl.hidden = true;
    }
  }

  if (mainImage && productMainImage) {
    mainImage.setAttribute('src', productMainImage);
    if (productMainImageSrcset) {
      mainImage.setAttribute('srcset', productMainImageSrcset);
    }
    mainImage.setAttribute('alt', productMainAlt);
  }

  if (secondaryImage) {
    secondaryImage.setAttribute('src', productSecondaryImage || productMainImage);
    secondaryImage.setAttribute('srcset', productSecondaryImageSrcset || productMainImageSrcset || '');
    secondaryImage.setAttribute('data-has-secondary', productHasSecondary);
    secondaryImage.setAttribute('alt', '');
  }

  const mobileMainImage = card.querySelector('[data-card-mobile-main-image]');
  const mobileSecondaryImage = card.querySelector('[data-card-mobile-secondary-image]');
  const mobileSecondarySlide = card.querySelector('[data-card-mobile-secondary-slide]');
  const mobileSlider = card.querySelector('[data-card-mobile-slider]');
  const hasMobileSecondary = productHasSecondary === 'true';

  if (mobileSlider && window.jQuery) {
    const $mobileSlider = jQuery(mobileSlider);

    if ($mobileSlider.hasClass('slick-initialized')) {
      $mobileSlider.slick('unslick');
    }
  }

  if (mobileMainImage && productMainImage) {
    mobileMainImage.setAttribute('src', productMainImage);
    mobileMainImage.setAttribute('srcset', productMainImageSrcset || '');
    mobileMainImage.setAttribute('alt', productMainAlt || '');
  }

  if (mobileSecondaryImage) {
    mobileSecondaryImage.setAttribute('src', hasMobileSecondary ? productSecondaryImage : productMainImage);
    mobileSecondaryImage.setAttribute('srcset', hasMobileSecondary ? productSecondaryImageSrcset : productMainImageSrcset || '');
    mobileSecondaryImage.setAttribute('alt', '');
  }

  if (mobileSecondarySlide) {
    if (hasMobileSecondary) {
      mobileSecondarySlide.classList.remove('is-hidden');
    } else {
      mobileSecondarySlide.classList.add('is-hidden');
    }
  }

  if (mobileSlider && typeof window.initMobileCardSliders === 'function') {
    setTimeout(function () {
      window.initMobileCardSliders();

      if (window.jQuery) {
        const $mobileSlider = jQuery(mobileSlider);

        if ($mobileSlider.hasClass('slick-initialized')) {
          $mobileSlider.slick('slickGoTo', 0, true);
          $mobileSlider.slick('setPosition');
        }
      }
    }, 50);
  }

  if (priceContainer && priceTemplateId) {
    const priceTemplate = document.getElementById(priceTemplateId);
    if (priceTemplate) {
      priceContainer.innerHTML = priceTemplate.innerHTML.trim();
    }
  }

  if (badgeTemplateId) {
    const badgeTemplate = document.getElementById(badgeTemplateId);

    if (badgeTemplate) {
      const badgeHtml = badgeTemplate.innerHTML.trim();

      if (badgeContainer) {
        badgeContainer.innerHTML = badgeHtml;

        if (productOnSale === 'true' && productFinalSale === 'true') {
          const badge = badgeContainer.querySelector('.badge');
          if (badge) badge.textContent = 'Final Sale';
        }
      }

      if (badgeTopContainer) {
        badgeTopContainer.innerHTML = badgeHtml;

        if (productOnSale === 'true' && productFinalSale === 'true') {
          const badge = badgeTopContainer.querySelector('.badge');
          if (badge) badge.textContent = 'Final Sale';
        }
      }


      if (badgeInlineContainer) {
        badgeInlineContainer.innerHTML = badgeHtml;

        if (productOnSale === 'true' && productFinalSale === 'true') {
          const badge = badgeInlineContainer.querySelector('.badge');
          if (badge) badge.textContent = 'Final Sale';
        }

        const productPreorder = swatch.dataset.productPreorder || '';
        if (productPreorder && !badgeInlineContainer.querySelector('.badge--sold-out')) {
          const preorderBadge = document.createElement('span');
          preorderBadge.className = 'badge badge--inline badge--preorder color-scheme-4';
          preorderBadge.textContent = productPreorder;
          badgeInlineContainer.appendChild(preorderBadge);
        }
      }

    }
  }

  allSwatches.forEach(function(item) {
    item.classList.remove('is-active');
  });
  swatch.classList.add('is-active');
}, true);




/* SCRIPT SLIDER MOBILE */

(function () {
  function initMobileCardSliders() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('[data-card-mobile-slider]').forEach(function (slider) {
      const $slider = jQuery(slider);
      const slidesCount = slider.querySelectorAll('.card-mobile-slide:not(.is-hidden)').length;

      if (isMobile && slidesCount > 1) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            swipe: true,
            touchMove: true,
            adaptiveHeight: false
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileCardSliders);
  window.addEventListener('resize', initMobileCardSliders);
  document.addEventListener('shopify:section:load', initMobileCardSliders);

  window.initMobileCardSliders = initMobileCardSliders;
})();